import { message, notification } from "antd";

export const showSuccess = (msg) => {
    message.success(msg);
  // notification.success({
  //   message: msg,
  //   description: "test",
  //   duration: 900000,
  //   showProgress: true,
  // });
};
export const showError = (msg) => {
  message.error(msg);
};
